module.exports = __webpack_public_path__ + "fonts/iconfont.143eb2fe.ttf";